import React, { useState, useCallback, useEffect } from 'react';
/*import { useAppBridge } from "@shopify/app-bridge-react";*/
import { ContextualSaveBar, Frame, Loading, Modal, Navigation, TextContainer, Toast, TopBar, AppProvider, FooterHelp, Icon, Page, Banner, Layout as LayoutPolaris } from '@shopify/polaris';
import en from '@shopify/polaris/locales/en.json';
import { ChartVerticalFilledIcon, MoneyIcon, CodeIcon, CartDiscountIcon, AppExtensionIcon, DiscountIcon, EmailIcon, HomeIcon, StoreImportIcon, InventoryIcon, ExitIcon, QuestionCircleIcon, SettingsIcon, ThemeIcon, NoteIcon, InfoIcon, NotificationIcon } from '@shopify/polaris-icons';

import { logoDarkIconCustom } from "../assets/images";
import { Outlet, Link as ReactLink, useLocation } from 'react-router-dom';
import ReactRouterPrompt from 'react-router-prompt';
import { NavMenu } from "@shopify/app-bridge-react";
import { usePrevious, useHostNavigate } from "../hooks";
import { loadTawk, loadInspectlet } from './../Utils';
import { AppBridgeProvider } from './providers';

function AdapterLink({ url, ...rest }) {
    return <ReactLink to={url} {...rest} />
}

export function Layout(props) {
    /*const shopify = useAppBridge();*/

    const navigate = useHostNavigate();
    const location = useLocation();

    const prevNavigate = usePrevious(navigate);
    const prevLocation = usePrevious(location);

    const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
    const [userMenuActive, setUserMenuActive] = useState(false);

    //const svgMoon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" shape-rendering="geometricPrecision"><g mask="url(#A)"><g transform="translate(10 21)"><g transform="translate(-10 -10)" fill="#ebaf26"><circle r="4" cx="10" cy="10"/><rect width="3" height="2" rx="1" x="2" y="9"/><rect width="3" height="2" rx="1" x="15" y="9"/><rect width="3" height="2" rx="1" transform="matrix(0 -1 1 0 9 18)"/><rect width="3" height="2" rx="1" transform="matrix(0 -1 1 0 9 5)"/><circle r="1" cx="15" cy="5"/><circle r="1" cx="15" cy="15"/><circle r="1" cx="5" cy="15"/><circle r="1" cx="5" cy="5"/></g></g><mask id="A"><path transform="translate(0 -10)" fill="#fff" d="M0 0h20v20H0z"/></mask></g><g mask="url(#B)"><path d="M4.378 15.001c-.793-.793-1.391-1.678-1.796-2.656A8.36 8.36 0 0 1 2 9.284a8.22 8.22 0 0 1 .632-3.036c.405-.995 1.012-1.897 1.821-2.707.247-.247.499-.474.755-.68.38-.306.871.133.744.604a7.91 7.91 0 0 0-.26 1.72 9.27 9.27 0 0 0 .531 3.39c.388 1.096.97 2.032 1.745 2.808.793.793 1.737 1.383 2.833 1.771s2.218.565 3.364.531c.613-.027 1.201-.117 1.762-.27.469-.128.904.359.6.739-.21.262-.441.518-.693.77-.809.809-1.712 1.417-2.707 1.821-.978.405-1.99.607-3.036.607-1.046.017-2.066-.169-3.061-.556-.978-.405-1.863-1.003-2.656-1.796z" fill="#6d7175"/><mask id="B"><path d="M2.378 13.002C1.585 12.21.987 11.324.582 10.346A8.36 8.36 0 0 1 0 7.285 8.22 8.22 0 0 1 .632 4.25c.405-.995 1.012-1.897 1.821-2.707.247-.247.499-.474.755-.68.38-.306.871.133.744.604a7.91 7.91 0 0 0-.26 1.72 9.27 9.27 0 0 0 .531 3.39c.388 1.096.97 2.032 1.745 2.808.793.793 1.737 1.383 2.833 1.771s2.218.565 3.364.531c.613-.027 1.201-.117 1.762-.27.469-.128.904.359.6.739-.21.262-.441.518-.693.77-.809.809-1.712 1.417-2.707 1.821-.978.405-1.99.607-3.036.607-1.046.017-2.066-.169-3.061-.556-.978-.405-1.863-1.003-2.656-1.796z" transform="translate(2 1.999)" fill="#fff"/></mask></g></svg>';
    //const svgSun = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" shape-rendering="geometricPrecision"><g mask="url(#A)"><g transform="translate(10 10)"><g transform="translate(-10 -10)" fill="#ebaf26"><circle r="4" cx="10" cy="10"/><rect width="3" height="2" rx="1" x="2" y="9"/><rect width="3" height="2" rx="1" x="15" y="9"/><rect width="3" height="2" rx="1" transform="matrix(0 -1 1 0 9 18)"/><rect width="3" height="2" rx="1" transform="matrix(0 -1 1 0 9 5)"/><circle r="1" cx="15" cy="5"/><circle r="1" cx="15" cy="15"/><circle r="1" cx="5" cy="15"/><circle r="1" cx="5" cy="5"/></g></g><mask id="A"><path transform="translate(0 -2)" fill="#fff" d="M0 0h20v20H0z"/></mask></g><g fill="#ebaf26"><rect width="12" height="1" rx=".5" fill-opacity="0" x="4" y="19"/><rect width="8" height="1" rx=".5" fill-opacity="0" x="6" y="21"/></g><g transform="translate(1 -3)" mask="url(#B)"><path d="M8.378 11.001c-.793-.793-1.391-1.678-1.796-2.656A8.36 8.36 0 0 1 6 5.284a8.22 8.22 0 0 1 .632-3.036C7.037 1.254 7.644.352 8.454-.458c.247-.247.499-.474.755-.68.38-.306.871.133.744.604a7.91 7.91 0 0 0-.26 1.72 9.27 9.27 0 0 0 .531 3.39c.388 1.096.97 2.032 1.745 2.808.793.793 1.737 1.383 2.833 1.771s2.218.565 3.364.531c.613-.027 1.201-.117 1.762-.27.469-.128.904.359.6.739-.21.262-.441.518-.693.77-.809.809-1.712 1.417-2.707 1.821-.978.405-1.99.607-3.036.607-1.046.017-2.066-.169-3.061-.556-.978-.405-1.863-1.003-2.656-1.796z" fill="#6d7175" fill-opacity="0"/><mask id="B"><path d="M2.378 13.002C1.585 12.21.987 11.324.582 10.346A8.36 8.36 0 0 1 0 7.285 8.22 8.22 0 0 1 .632 4.25c.405-.995 1.012-1.897 1.821-2.707.247-.247.499-.474.755-.68.38-.306.871.133.744.604a7.91 7.91 0 0 0-.26 1.72 9.27 9.27 0 0 0 .531 3.39c.388 1.096.97 2.032 1.745 2.808.793.793 1.737 1.383 2.833 1.771s2.218.565 3.364.531c.613-.027 1.201-.117 1.762-.27.469-.128.904.359.6.739-.21.262-.441.518-.693.77-.809.809-1.712 1.417-2.707 1.821-.978.405-1.99.607-3.036.607-1.046.017-2.066-.169-3.061-.556-.978-.405-1.863-1.003-2.656-1.796z" transform="translate(2 1.999)" fill="#fff"/></mask></g></svg>';

    const handleLogOut = useCallback(
        () => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        },
        [],
    );

    const toggleUserMenuActive = useCallback(
        () => setUserMenuActive(!userMenuActive),
        [userMenuActive],
    );

    const toggleMobileNavigationActive = useCallback(
        () => setMobileNavigationActive(!mobileNavigationActive),
        [mobileNavigationActive],
    );

    const toggleNotifications = function () {
        var el = document.querySelector('.Polaris-TopBar__SecondaryMenu .btn-notifications');
        el.blur();
        navigate('/notifications');
    }

    const populateData = async () => {

        if (window.location.pathname.startsWith('/login')) {
            return;
        }

        if (props.user && props.user.myShopifyDomain && !props.user.viewOnly) {
            loadTawk(props.user.myShopifyDomain, props.user.name);
        }

        //if (!props.user.viewOnly) {
        //    loadInspectlet();
        //}
    };

    useEffect(() => {
        if (JSON.stringify(props.user) !== '{}') {
            populateData();
        }
        // eslint-disable-next-line
    }, [props.user]);

    useEffect(() => {
        if ((prevLocation || location) && ((!prevLocation && location) || (prevLocation && !location) || prevLocation.pathname !== location.pathname)) {
            props.setIsDirty(false);
        }
        // eslint-disable-next-line
    }, [location]);

    //useEffect(() => {
    //    if (JSON.stringify(model) !== '{}' && initState.hasEndDate !== model.hasEndDate) {
    //        enableDisableCallback();
    //    }
    //}, [model.hasEndDate]);

    const logo = {
        width: 130,
        topBarSource: logoDarkIconCustom,
        contextualSaveBarSource: logoDarkIconCustom,
        url: '/',
        accessibilityLabel: 'Stack Discounts',
    };

    const userMenuActions = [
        {
            items: [
                { content: 'Open Storefront', icon: StoreImportIcon, onAction: () => { window.open(props.user.storefrontUrl, '_blank'); } },
                {
                    content: 'Open Shopify Admin', icon: InventoryIcon, onAction: () => {
                        if (props.user.viewOnly) return;
                        window.open(props.user.shopifyAdminUrl, '_blank');
                    }
                }
            ]
        },
        {
            items: [
                { content: 'Log out', icon: ExitIcon, onAction: handleLogOut }
            ],
        },
    ];

    const userMenuMarkup = props.user.name ? (
        <TopBar.UserMenu
            actions={userMenuActions}
            name={props.user.name}
            detail={props.user.shopName}
            initials={props.user.nameInitials}
            open={userMenuActive}
            onToggle={toggleUserMenuActive}
        />
    ) : null;

    const topBarMarkup = (
        <TopBar
            showNavigationToggle
            userMenu={userMenuMarkup}
            onNavigationToggle={toggleMobileNavigationActive}
        />
    );

    const navItems = [];
    navItems.push({
        url: '/',
        label: 'Dashboard',
        icon: HomeIcon,
        exactMatch: true,
        onClick: () => {
            if (mobileNavigationActive) { toggleMobileNavigationActive(); }
        }
    });

    navItems.push({
        url: '/campaigns',
        label: 'Campaigns',
        icon: DiscountIcon,
        onClick: () => {
            if (mobileNavigationActive) { toggleMobileNavigationActive(); }
        }
    });

    if (props.user.adminEnabled && !props.user.viewOnly) {
        navItems.push({
            url: '/widgets',
            label: 'Widgets',
            icon: AppExtensionIcon,
            onClick: () => {
                if (mobileNavigationActive) { toggleMobileNavigationActive(); }
            }
        });
    }

    navItems.push({
        url: '/themes',
        label: 'Themes',
        icon: ThemeIcon,
        onClick: () => {
            if (mobileNavigationActive) { toggleMobileNavigationActive(); }
        }
    });

    navItems.push({
        url: '/analytics',
        label: 'Analytics',
        icon: ChartVerticalFilledIcon,
        onClick: () => {
            if (mobileNavigationActive) { toggleMobileNavigationActive(); }
        }
    });

    navItems.push({
        url: '/settings',
        label: 'Settings',
        icon: SettingsIcon,
        onClick: () => {
            if (mobileNavigationActive) { toggleMobileNavigationActive(); }
        },
        selected: window.location.pathname.startsWith('/settings') || window.location.pathname.startsWith('/settings/billing') || window.location.pathname.startsWith('/settings/partners')
    });

    //navItems.push({
    //    url: '/billing',
    //    label: 'Billing',
    //    icon: MoneyIcon,
    //    onClick: () => {
    //        if (mobileNavigationActive) { toggleMobileNavigationActive(); }
    //    }
    //});

    //navItems.push({
    //    url: '/notifications',
    //    label: 'Notifications',
    //    icon: NotificationIcon,
    //    onClick: () => {
    //        if (mobileNavigationActive) { toggleMobileNavigationActive(); }
    //    }
    //});

    //navItems.push({
    //    label: 'Documentation',
    //    icon: NoteIcon,
    //    onClick: () => {
    //        window.open('https://uniocode.gitbook.io/stack-discounts/1.-getting-started', '_blank');
    //        if (mobileNavigationActive) { toggleMobileNavigationActive(); }
    //    }
    //});

    //navItems.push({
    //    url: '/faq',
    //    label: 'FAQ',
    //    icon: QuestionCircleIcon,
    //    onClick: () => {
    //        if (mobileNavigationActive) { toggleMobileNavigationActive(); }
    //    }
    //});

    //navItems.push({
    //    label: 'Support',
    //    icon: EmailIcon,
    //    onClick: () => {
    //        window.open('https://stackdiscounts.freshdesk.com/support/tickets/new', '_blank');
    //        if (mobileNavigationActive) { toggleMobileNavigationActive(); }
    //    }
    //});

    if (props.user.adminEnabled && !props.user.viewOnly) {
        navItems.push({
            url: '/advanced',
            label: 'Advanced',
            icon: CodeIcon,
            onClick: () => {
                if (mobileNavigationActive) { toggleMobileNavigationActive(); }
            }
        });
    }

    const navigationMarkup = props.user.name ? (
        <Navigation location={window.location.pathname}>
            <Navigation.Section
                title=""
                fill
                items={navItems}
            />
            <Navigation.Section
                items={[
                    {
                        label: 'Open Storefront',
                        icon: StoreImportIcon,
                        onClick: () => {
                            window.open(props.user.storefrontUrl, '_blank');
                            if (mobileNavigationActive) { toggleMobileNavigationActive(); }
                        }
                    },
                    {
                        label: 'Open Shopify Admin',
                        icon: InventoryIcon,
                        onClick: () => {
                            if (props.user.viewOnly) return;
                            window.open(props.user.shopifyAdminUrl, '_blank');
                            if (mobileNavigationActive) { toggleMobileNavigationActive(); }
                        }
                    }
                ]}
            />
            <Navigation.Section
                items={[]}
            />
        </Navigation>
    ) : null;

    const navigationMarkupBridge = props.user.name ? (
        <NavMenu>
            <a href="/" rel="home">Dashboard</a>
            <a href="/campaigns">Campaigns</a>
            {
                props.user.adminEnabled ?
                    <a href="/widgets">Widgets</a>
                    : null
            }
            <a href="/themes">Themes</a>
            <a href="/analytics">Analytics</a>
            <a href="/settings">Settings</a>
        </NavMenu>
    ) : null;

    const loadingMarkup = props.isLoading ? <Loading /> : null;

    const promptMarkup = <ReactRouterPrompt when={props.isDirty}>
        {({ isActive, onConfirm, onCancel }) => (
            props.isEmbed ?
                <></>
                :
                <Modal
                    open={isActive}
                    onClose={onCancel}
                    title="You have unsaved changes"
                    primaryAction={{
                        content: 'Leave page',
                        onAction: onConfirm,
                        destructive: true
                    }}
                    secondaryActions={[
                        {
                            content: 'Cancel',
                            onAction: onCancel,
                        },
                    ]}
                >
                    <Modal.Section>
                        <TextContainer>
                            <p>If you leave this page, all unsaved changes will be lost.</p>
                        </TextContainer>
                    </Modal.Section>
                </Modal>
        )}
    </ReactRouterPrompt>

    const contextualSaveBarMarkup = props.isDirty ? (
        <ContextualSaveBar
            message="Unsaved changes"
            saveAction={{
                onAction: () => {
                    if (props.user.viewOnly) return;
                    props.setTriggerSave(true);
                },
            }}
            discardAction={{
                onAction: () => { props.setTriggerDiscard(true); },
            }}
        />
    ) : null;

    const contextualSaveBarMarkupBridge = <ui-save-bar id="bridge-save-bar">
        <button variant="primary" onClick={() => { props.setTriggerSave(true); }}></button>
        <button onClick={() => { props.setTriggerDiscard(true); }}></button>
    </ui-save-bar>

    const toastMarkup = props.toastActive ? (
        <Toast onDismiss={props.toggleToastActive} content={props.toastMessage} />
    ) : null;

    return (
        <AppProvider i18n={en} linkComponent={AdapterLink}>
            <Frame
                logo={!props.isEmbed ? logo : null}
                topBar={!props.isEmbed ? topBarMarkup : null}
                navigation={!props.isEmbed ? navigationMarkup : null}
                showMobileNavigation={!props.isEmbed ? mobileNavigationActive : null}
                onNavigationDismiss={!props.isEmbed ? toggleMobileNavigationActive : null}
            >
                {loadingMarkup}
                {/*{props.isEmbed ? shopify.loading(props.isLoading) : null}*/}
                {toastMarkup}
                {/*{props.isEmbed && props.toggleToastActive ? shopify.toast.show(props.toastMessage) : null}*/}
                {!props.isEmbed ? contextualSaveBarMarkup : null}
                {promptMarkup}
                {
                    props.isEmbed ?
                        <AppBridgeProvider>
                            {navigationMarkupBridge}
                            {contextualSaveBarMarkupBridge}
                            <Outlet />
                        </AppBridgeProvider>
                        :
                        <Outlet />
                }
                <FooterHelp>
                    <span className="footer-links">
                        <Icon source={InfoIcon} tone="info" />
                        <a href="https://stackdiscounts.freshdesk.com/support/tickets/new" target="_blank" rel="noreferrer" className="Polaris-Link">Support</a>
                        <a href="https://uniocode.gitbook.io/stack-discounts/1.-getting-started" target="_blank" rel="noreferrer" className="Polaris-Link">Documentation</a>
                        <a href="https://uniocode.gitbook.io/stack-discounts/faq" target="_blank" rel="noreferrer" className="Polaris-Link">FAQ</a>
                        <a href="https://uniocode.gitbook.io/stack-discounts/terms-and-conditions" target="_blank" rel="noreferrer" className="Polaris-Link">Terms and Conditions</a>
                        <a href="https://uniocode.gitbook.io/stack-discounts/privacy-policy" target="_blank" rel="noreferrer" className="Polaris-Link">Privacy Policy</a>
                    </span>
                </FooterHelp>
            </Frame>
        </AppProvider>
    );
}